<div class="notice-container">
    <div>
        <div class="sorry-title">
            Sorry!
        </div>    
        <div class="top-border-box">
            We looked everywhere for this page. Are you sure the website URL is correct?
        </div>
        <button mat-raised-button [routerLink]="['/']" class="leprechaunButton mt">HOME</button>
    </div>
</div>
